<template>
    <Drawer id="account-menu" class="menu-account">
        <PortalView drawer/>
    </Drawer>
</template>

<script setup lang="ts">
import {onUnmounted} from 'vue';
import PortalView from '../../views/portal/PortalView.vue';
import {Drawer} from '@helcim/blizzard';


onUnmounted(() => {
    document.body.style.position = '';
});
</script>
